
export { CollectionName } from "/codebuild/output/src1825891555/src/packages/search-document-builders/src/registry/collection-registry.ts"
export { collectionAlias } from "./registry/schema-registry"